// extracted by mini-css-extract-plugin
export var modal = "_vn-0";
export var table = "_vn-1";